"use client";

import { useRouter, useSearchParams } from "next/navigation";

import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/lib/components/select";

interface FilterBarProps {
	providers: string[];
}

export function FilterBar({ providers }: FilterBarProps) {
	const router = useRouter();
	const searchParams = useSearchParams();

	const period = searchParams.get("period") || "30d";
	const provider = searchParams.get("provider") || "all";
	const sortBy = searchParams.get("sortBy") || "requests";

	const updateFilter = (key: string, value: string) => {
		const params = new URLSearchParams(searchParams);
		if (value === "all") {
			params.delete(key);
		} else {
			params.set(key, value);
		}
		router.push(`/ranking?${params.toString()}`, { scroll: false });
	};

	return (
		<div className="flex flex-col gap-4 md:flex-row md:items-end md:gap-3">
			<div className="flex flex-col gap-2">
				<label className="text-sm font-medium">Time Period</label>
				<Select value={period} onValueChange={(v) => updateFilter("period", v)}>
					<SelectTrigger className="w-[180px]">
						<SelectValue />
					</SelectTrigger>
					<SelectContent>
						<SelectItem value="24h">Last 24 Hours</SelectItem>
						<SelectItem value="7d">Last 7 Days</SelectItem>
						<SelectItem value="30d">Last 30 Days</SelectItem>
						<SelectItem value="90d">Last 90 Days</SelectItem>
						<SelectItem value="all-time">All Time</SelectItem>
					</SelectContent>
				</Select>
			</div>

			<div className="flex flex-col gap-2">
				<label className="text-sm font-medium">Provider</label>
				<Select
					value={provider}
					onValueChange={(v) => updateFilter("provider", v)}
				>
					<SelectTrigger className="w-[180px]">
						<SelectValue />
					</SelectTrigger>
					<SelectContent>
						<SelectItem value="all">All Providers</SelectItem>
						{providers.map((p) => (
							<SelectItem key={p} value={p}>
								{p.charAt(0).toUpperCase() + p.slice(1)}
							</SelectItem>
						))}
					</SelectContent>
				</Select>
			</div>

			<div className="flex flex-col gap-2">
				<label className="text-sm font-medium">Sort By</label>
				<Select value={sortBy} onValueChange={(v) => updateFilter("sortBy", v)}>
					<SelectTrigger className="w-[180px]">
						<SelectValue />
					</SelectTrigger>
					<SelectContent>
						<SelectItem value="requests">Most Popular</SelectItem>
						<SelectItem value="latency">Fastest</SelectItem>
						<SelectItem value="successRate">Most Reliable</SelectItem>
						<SelectItem value="cost">Best Cost</SelectItem>
					</SelectContent>
				</Select>
			</div>
		</div>
	);
}
